import { FootchinkoItem } from "./FootchinkoItem";
import { GameConstants } from "../../GameConstants";
import { GoalKeeper } from "./GoalKeeper";
import { FootballFieldState } from "../../scenes/match-scene/FootballFieldState";
import { AudioManager } from "../../AudioManager";

    export class MagicPotion extends FootchinkoItem {

        private ray: Phaser.Sprite;

        constructor(game: Phaser.Game, x: number, y: number) {

            super(game, x, y, "texture_atlas_1", false, true);

            this.canBeHit = true;
        }

        public setBody(): void {

            this.body.setCircle(28);
            this.body.static = true;
        }

        public setView(): void {

            super.setView();

            this.name = GameConstants.MAGIC_POTION;
            this.anchor.setTo(0.5, 0.5);

            // parte gráfica
            this.animations.add("spin", Phaser.Animation.generateFrameNames("pocima_pato", 1, 7, "", 4), 16, true);
            this.animations.play("spin");
        }

        public hit(): void {

            super.hit();

            this.visible = false;
            this.body.destroy();
            this.body = null;

            // ponerlo por encima de todo
            this.bringToTop();

            // la posicion del portero
            var goalKeeper: GoalKeeper = FootballFieldState.currentInstance.goalKeeper;

            var distance: number = Phaser.Math.distance(this.x, this.y, goalKeeper.x, goalKeeper.y);

            // poner el rayo
            this.ray = new Phaser.Sprite(this.game, this.x, this.y, "texture_atlas_5");
            this.ray.animations.add("ray_animation", Phaser.Animation.generateFrameNames("magic_potion_ray_", 1, 6, "", 4), 16, false);
            this.ray.animations.play("ray_animation", 16, false, true);
            this.ray.anchor.set(.5, 0);
            this.ray.scale.set(1, distance / 380); // 380 es la altura de todas las imagenes
            this.ray.angle = Math.atan( - (goalKeeper.x - this.x) / (goalKeeper.y - this.y) ) * 180 / Math.PI ;
            FootballFieldState.currentInstance.add.existing(this.ray);

            this.game.time.events.add(1100, this.removeMagicPotion, this);

            AudioManager.getInstance().playEffect("quemar_rival");
        }

        public makeVoodoo(): void {

            this.animations.stop("spin");
            super.makeVoodoo();
        }

        private removeMagicPotion(): void {

            this.ray.destroy();
            this.destroy();
        }
    }
